import { compose, withApollo } from "react-apollo";
import { connect } from "react-redux";
import { updateNotificationBanner } from "../landingPageUser/redux/actions";
import TopBannerNotification from "./TopBannerNotification";


const TopBannerSection = ({NotificationBanner}) => {

  const TopBannerDatas = NotificationBanner;
 
  return (
    <TopBannerNotification TopBannerDatas={TopBannerDatas}/>
  );
};

const mapStateToProps = (state) => ({
  NotificationBanner: state.user.NotificationBanner
});

export default compose(
  connect(mapStateToProps, {
    UpdateNotificationBanner: updateNotificationBanner
  }),
  withApollo
)(TopBannerSection);
